<template>
  <div>
    <!-- 登录 -->
    <LoginModal ref="loginModal" @change="setData" />
    <!-- 注册扫码授权 -->
    <CodeModal ref="codeModal" @change="setData" />
    <!-- 最后提示 -->
    <TipModal ref="tipModal" />
    <TipModal2 ref="tipModal2" />
  </div>
</template>
<script>
import LoginModal from "./components/login_modal";
import CodeModal from "./components/code_modal";
import TipModal from "./components/tip_modal";
import TipModal2 from "./components/tip_modal2";
import handler from "./handler";
import { Service_GetZfbMemberToken } from "@/service/platform_config";
export default {
  components: { LoginModal, CodeModal, TipModal, TipModal2 },
  methods: {
    // 提交信息后
    setData(result) {
      // 说明登录成功，获取用户详情并存到本地
      if (result.Token) {
        handler.SetUserInfoToLocal(result.Token);
        this.$refs.tipModal.show();
      }
      // 说明需要注册，要先支付宝扫码授权
      else if (result.QrCodeUrl) this.$refs.codeModal.show(result);
    },
  },
  mounted() {
    // 如果本地没有信息则弹出登录框
    !Service_GetZfbMemberToken() && this.$refs.loginModal.show();
    if (
      Service_GetZfbMemberToken() &&
      (!localStorage.getItem("showTipImg") || localStorage.getItem("showTipImg") == 0)
    ) {
      //有授权后 显示一次通知图片
      localStorage.setItem("showTipImg", 1);
      this.$refs.tipModal2.show();
    }
    if (!Service_GetZfbMemberToken()) {
      localStorage.setItem("showTipImg", 0);
    }
  },
};
</script>
